import { FinancialGatewayToken } from '/@/modules/financialgateway/models/FinancialGatewayToken';
import { FinancialAccount } from '/@/modules/financialaccount/models/FinancialAccount';
import { FinancialInstitution } from '/@/modules/predefined/models/FinancialInstitution';

export class ConnectedFinancialInstitution extends FinancialInstitution {
  financialAccounts: FinancialAccount[];

  financialGatewayToken: FinancialGatewayToken | null;

  constructor(model: Partial<ConnectedFinancialInstitution> = {}) {
    super(model);

    this.financialAccounts = FinancialAccount.mapModels(model.financialAccounts);
    this.financialGatewayToken = FinancialGatewayToken.mapModelOrNull(model.financialGatewayToken);
  }
}
